<template>
	<div @click.stop="cancel()" class="commonModalBlo">
		<div @click.stop="noCancel()" class="commonModal modal equipmentRegistrationModal">
			<div class="commonTitle displayFSpaceBetween">
				<div>
					{{propsObj.title}}
				</div>

				<img @click.stop="cancel()" :src="initThemeImg(theme, 'icon_no@2x')" alt="" class="imgWH16 cursor">
			</div>

			<div class="commonCon">
				<el-form @submit.native.prevent :model="formData" ref="formDataRef" :rules="rules" label-width="auto" label-position="left">
					<el-form-item label="设备图片" class="widthPercentage">
						<div class="imgWH102 positionR displayFCenter back_272 borderRadius4 overflowH">
							<div class="equipmentRemarkBloSty">
								前面
							</div>

							<img v-if="inFrontUrl" :src="inFrontUrl" alt="" class="imgWH102 objectFitC">
							<div v-else>
								<div>
									<img :src="initThemeImg(theme, 'noImg@2x')" alt="" class="noImgBloSty">
								</div>
								<div class="opacity05 fontSize12 color_B9B lineHeight18 textAlignC">
									暂无图片
								</div>
							</div>
						</div>
					</el-form-item>

					<div class="displayF flexWrap columnGap48">
						<el-form-item label="申请设备">
							<div class="detailsBloSty">
								{{formData.deviceName || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="编号">
							<div class="detailsBloSty">
								{{formData.deviceCode || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="类别">
							<div class="detailsBloSty">
								{{formData.deviceTypeName || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="品牌">
							<div class="detailsBloSty">
								{{formData.deviceBrand || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="型号">
							<div class="detailsBloSty">
								{{formData.deviceModel || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="运行状态">
							<div class="detailsBloSty">
								{{formData.deviceRunState || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="使用人">
							<div class="detailsBloSty">
								{{formData.useUserInfo || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="申请人">
							<div class="detailsBloSty">
								{{formData.applyUserInfo || '-'}}
							</div>
						</el-form-item>

						<el-form-item label="申请时间">
							<div class="detailsBloSty">
								<div>
									{{formData.createTime || '-'}}
								</div>
							</div>
						</el-form-item>

						<el-form-item label="使用时长">
							<div class="detailsBloSty">
								<div>
									{{formData.useTime || '-'}}
								</div>
							</div>
						</el-form-item>

						<el-form-item label="规格参数">
							<div class="detailsBloSty detailsBloStyBig">
								<div>
									{{formData.deviceParam || '-'}}
								</div>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>

			<div class="buttonBlo buttonBloP">
				<el-button @click="submitHandle(1)" type="primary" :loading="loading">
					通过
				</el-button>
				
				<el-button @click="submitHandle(2)" type="primary" :loading="loading">
					否决
				</el-button>
				
				<!-- 20260302 注释原按钮逻辑 -->
				<!-- <div class="left" @click="submitHandle(1)">通过</div>
				<div class="dangerButton" @click="submitHandle(2)">否决</div> -->
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getRemark,
		initThemeImg,
		setMessageQueue
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'
	import {
		archivedeviceapplyInfo
	} from '@/api/archivePage'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		propsObj: {
			type: Object,
			default: () => {}
		}
	})

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const userInfo = computed(() => {
		return useUserStore().userInfo
	})
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	
	const formData = ref({
		fileList: []
	})
	const inFrontUrl = ref('') // 正面图片
	const rules = {
		date: [{
			required: true,
			message: '请选择',
			trigger: ['change', 'blur']
		}],
		maintainReason: [{
			required: true,
			message: '请输入',
			trigger: ['change', 'blur'],
		}],
		longTime: [{
			required: true,
			message: '请选择',
			trigger: ['change', 'blur']
		}],
	}
	
	const loading = ref(false)
	
	watch(() => props.propsObj, val => {
		if (val.loadingReset) {
			loading.value = false
		}
	
		// console.log(val, loading.value, 'val propsObj watch')
	}, {
		deep: true,
		immediate: true
	})
	
	function cancel() {
		proxy.$emit('cancelHandle')
	}

	function noCancel() {
		return
	}

	function submitHandle(type) {
		proxy.$refs.formDataRef.validate(valid => {
			if (valid) {
				proxy.$emit('sureHandle', type)
				// 弹窗 可直接禁用按钮
				loading.value = true
			} else {
				return false
			}
		})
	}

	// 查询详情
	function getDetails(id) {
		archivedeviceapplyInfo({
			id
		}).then(res => {
			if (res) {
				let data = res.data
				let fileList = data.fileList
				formData.value = data

				if (fileList.length > 0) {
					let index = fileList.findIndex(val => {
						return val.remark === '0'
					})

					if (index > -1) {
						inFrontUrl.value = fileList[index].url
					}
				}
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 选择使用时长
	function changeHandle(type) {
		if (type === 'date') {
			formData.value.longTime = 0
		} else {
			formData.value.date = null
		}
	}
	
	// 监听键盘键
	function keyDown(e) {
		let shortcutModelArr = userConfigData.value.shortcutModelArr
		console.log(e, 'e keyDown document.activeElement', document.activeElement)
		if (e.keyCode === 27) {
			if (shortcutModelArr.includes(3)) {
				// Esc键的ASCII是27
				cancel()
			}
		}
		
		// tab加日志
		if (e.key === 'Tab') {
			console.log(e, 'e keyDown Tab document.activeElement', document.activeElement)
		}
	}
	
	onUnmounted(() => {
		useUserStore().isModal = false
		
		window.removeEventListener('keydown', keyDown, true)
	})

	onMounted(() => {
		// 当前是弹窗
		useUserStore().isModal = true
		// 查询详情
		getDetails(props.propsObj.data)
		
		// 绑定监听事件
		window.addEventListener('keydown', keyDown, true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	:deep(.el-form .el-form-item__label) {
		line-height: 32px !important;
		height: 32px !important;
	}

	.commonModalBlo .modal {
		width: 800px;
		height: 622px;

		.detailsBloSty {
			width: 246px;
			line-height: 32px;
			padding: 0 16px;
			border-radius: 2px;
			font-size: 14px;
			box-sizing: border-box;
			@include color('color_FFF');
			@include background('color_272');
		}

		.detailsBloStyBig {
			width: 620px;
		}
	}

	:deep(.el-date-editor.el-input, .el-date-editor.el-input__wrapper) {
		width: 246px !important;
	}

	.equipmentRemarkBloSty {
		width: 44px;
		height: 20px;
		font-size: 12px;
		line-height: 20px;
	}

	.noImgBloSty {
		width: 40px;
		margin: 2px auto 8px;
	}
</style>